import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin } from "lucide-react";
import Logo from "../assets/images/logo/logo.png";
import { Link } from "react-router-dom";
import VersatileLogo from '../assets/images/logo/versatile.png';

const Footer = () => {
  return (
    <footer className="bg-[#0c2340] text-white pt-16">

      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-4 gap-12">

        {/* LOGO + ABOUT */}
        <Link to="/">
          <img src={Logo} className="h-16 mb-4 bg-white p-2 rounded" />

          <p className="text-slate-300 text-sm leading-relaxed">
            Dr. Sachitanand Chaurasia is a trusted urology expert in Bhilwara,
            known for advanced kidney, prostate and urology treatments with
            modern technology and patient-focused care.
          </p>
        </Link>

        {/* QUICK LINKS */}
        <div>
          <h3 className="font-bold text-lg mb-4">Quick Links</h3>
          <ul className="space-y-2 text-slate-300">

            <li><Link to="/" className="hover:text-secondary">Home</Link></li>
            <li><Link to="/about" className="hover:text-secondary">About Doctor</Link></li>
            <li><Link to="/#appointment" className="hover:text-secondary">Book Appointment</Link></li>
            <li><Link to="/contact" className="hover:text-secondary">Contact Us</Link></li>
          </ul>
        </div>

        {/* TREATMENTS */}
        <div>
          <h3 className="font-bold text-lg mb-4">Treatments</h3>
          <ul className="space-y-2 text-slate-300">

            <li><Link to="/treatments/laser-kidney-stone" className="hover:text-secondary">Laser Kidney Stone</Link></li>
            <li><Link to="/treatments/laparoscopic-urology" className="hover:text-secondary">Laparoscopic Urology</Link></li>
            <li><Link to="/treatments/kidney-transplant" className="hover:text-secondary">Kidney Transplant</Link></li>
            <li><Link to="/treatments/endourology" className="hover:text-secondary">Endourology</Link></li>
            <li><Link to="/treatments/prostate-enlargement" className="hover:text-secondary">Prostate Treatment</Link></li>
            <li><Link to="/treatments/urologic-oncology" className="hover:text-secondary">Urologic Oncology</Link></li>

          </ul>
        </div>

        {/* CONTACT */}
        <div>
          <h3 className="font-bold text-lg mb-4">Contact Information</h3>

          <div className="space-y-4 text-slate-300 text-sm">

            <div className="flex gap-3">
              <MapPin size={18} />
              <p>BBMH Hospital, RC Vyas Colony, Bhilwara, Rajasthan</p>
            </div>

            <a href="tel:+917774956489" className="flex gap-3 hover:text-white">
              <Phone size={18} />
              <p>+91 77749 56489</p>
            </a>

            <a href="mailto:drsachiturologist@gmail.com" className="flex gap-3 hover:text-white">
              <Mail size={18} />
              <p>drsachiturologist@gmail.com</p>
            </a>

          </div>
        </div>
      </div>

      {/* bottom */}
      <div className="border-t border-white/20 mt-12 py-6">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4">

          <p className="text-sm text-slate-300 flex flex-col md:flex-row gap-2 items-center text-center lg:text-start">
            © 2026 Dr. Sachitanand Chaurasia. All Rights Reserved. | Design & Developed by
            <Link to="http://www.versatileitsolution.com" className="text-[#E5C07B] hover:text-white flex items-center gap-1">
              <img alt="Versatile IT Solution" className="h-5" src={VersatileLogo} />
            </Link>
          </p>

          {/* social */}
          <div className="flex gap-4">

            <a href="https://www.facebook.com/people/Dr-SN-Chaurasia-Urologist/61568803236262/" target="_blank" className="bg-blue-600 p-2 rounded hover:scale-110 transition">
              <Facebook size={18} />
            </a>

            <a href="https://www.instagram.com/drsachitanand/" target="_blank" className="bg-pink-600 p-2 rounded hover:scale-110 transition">
              <Instagram size={18} />
            </a>

            <a href="https://www.linkedin.com/in/sachitanand-chaurasia-19655a281/" target="_blank" className="bg-[#0077B5] p-2 rounded hover:scale-110 transition">
              <Linkedin size={18} />
            </a>

          </div>

        </div>
      </div>

    </footer>
  );
};

export default Footer;
